import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-bell_svg__a"
        d="M16.567 13.6c-.301-.4-.402-.9-.402-1.3V12c0-2.2-1.81-4-4.021-4-2.212 0-4.022 1.8-4.022 4v.2c0 .5-.1.9-.402 1.3L6.01 16h12.267l-1.71-2.4zm-6.434-7.3V6a2.011 2.011 0 014.021 0v.3c2.313.8 4.022 3 4.022 5.7v.4l1.71 2.4c.602.9.401 2.1-.504 2.8-.301.2-.703.4-1.206.4H6.011C4.905 18 4 17.1 4 16c0-.4.1-.8.402-1.2l1.71-2.4V12c0-2.6 1.708-4.8 4.02-5.7zM9.127 19h6.033c-.302 1.1-1.609 2-3.016 2-1.408 0-2.715-.8-3.017-2z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-bell_svg__a"
    />
  </svg>
);
